// extracted by mini-css-extract-plugin
export default {"bigContainer":"Admin_bigContainer__QXJml","buttons":"Admin_buttons__JKYLP","btnActive":"Admin_btnActive__cV6lE"};